import React, { useState } from 'react';
// import './ProfitLoss.scss' // Removed as Tailwind CSS replaces it
import { ThreeDots } from "react-loader-spinner";
import { toast } from "react-toastify";
// import Swal from "sweetalert2"; // Not used in the provided snippet, so removed
import { api_url } from "../../data";
import axios from 'axios';
import { useAuth } from '../../context/Auth';

const ProfitLossStatement = () => {
    const {requestWithAuth} = useAuth();
    const [incomeStatement, setIncomeStatement] = useState(null); // Changed initial state to null for clearer data presence check
    const [startDate, setStartDate] = useState(""); // Changed initial state to empty string for date inputs
    const [endDate, setEndDate] = useState(""); // Changed initial state to empty string for date inputs
    const [gettingData, setGettingData] = useState(false);
    const [dataFetched, setDataFetched] = useState(false); // Added to track if data has been fetched

    // Helper to format currency
    const formatCurrency = (amount) => {
        if (typeof amount !== 'number' && typeof amount !== 'string') return 'N/A';
        const num = parseFloat(amount);
        if (isNaN(num)) return 'N/A';
        return `GHS ${num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    };

    const getIncomeStatement = async (e) => {
        e.preventDefault();

        
        if (!startDate || !endDate) {
            toast.error("Please select both start and end dates.");
            return;
        }
        if (new Date(startDate) > new Date(endDate)) {
            toast.error("Start date cannot be after end date.");
            return;
        }

        
        try {
            setGettingData(true)
            const response = await requestWithAuth(`/finance/income-statement/${startDate}/${endDate}/`, "GET");
            setIncomeStatement(response);
            console.log(response)
            toast.success("Income statement fetched successfully!");
            setDataFetched(true);
        } catch (error) {
            console.error("Error fetching income statement:", error);
            const errorMessage = error.response?.data?.message || "An error occurred while fetching data.";
            toast.error(errorMessage);
            setIncomeStatement(null); 
        }finally{
            setGettingData(false);
        }

        
    };

    return (
        <div className="container mx-auto p-4 sm:p-6 lg:p-8 bg-gray-100 min-h-screen">
            <h1 className="text-3xl font-extrabold text-gray-800 mb-6 text-center">Profit & Loss Statement</h1>

            <div className="bg-white shadow-lg rounded-xl p-6 mb-8 border border-gray-200">
                <form onSubmit={getIncomeStatement} className="flex flex-col sm:flex-row items-center justify-center gap-4">
                    <div className="flex flex-col w-full sm:w-auto">
                        <label htmlFor="startDate" className="text-sm font-medium text-gray-700 mb-1">Start Date</label>
                        <input
                            required
                            onChange={(e) => setStartDate(e.target.value)}
                            type="date"
                            name="start_date"
                            id="startDate"
                            className="p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 text-gray-700"
                            value={startDate} // Controlled component
                        />
                    </div>
                    <div className="flex flex-col w-full sm:w-auto">
                        <label htmlFor="endDate" className="text-sm font-medium text-gray-700 mb-1">End Date</label>
                        <input
                            required
                            onChange={(e) => setEndDate(e.target.value)}
                            type="date"
                            name="end_date"
                            id="endDate"
                            className="p-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 text-gray-700"
                            value={endDate} 
                        />
                    </div>
                    <div className="mt-8 sm:mt-0"> {/* Adjust margin for alignment */}
                        {gettingData ? (
                            <div className="flex justify-center items-center h-10 w-28"> 
                                <ThreeDots
                                    height="40"
                                    width="40"
                                    radius="9"
                                    color="#4F46E5" 
                                    ariaLabel="loading data"
                                    visible={true}
                                />
                            </div>
                        ) : (
                            <button
                                type="submit"
                                className="w-full sm:w-auto bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-2 px-6 rounded-md shadow-md transition duration-300 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                            >
                                Get Statement
                            </button>
                        )}
                    </div>
                </form>
            </div>

            {incomeStatement ? (
                <div className="profit-loss-statement bg-white shadow-lg rounded-xl overflow-hidden border border-gray-200">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="px-6 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                    Category
                                </th>
                                <th className="px-6 py-3 text-right text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                    Amount (GHS)
                                </th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            <tr className="bg-gray-100">
                                <td className="px-6 py-3 whitespace-nowrap text-lg font-bold text-gray-800">
                                    Income
                                </td>
                                <td className="px-6 py-3 whitespace-nowrap text-right"></td>
                            </tr>
                            {incomeStatement?.incomes?.length > 0 ? (
                                incomeStatement.incomes.map((income, index) => (
                                    <tr key={index} className="even:bg-gray-50 hover:bg-blue-50 transition-colors duration-150">
                                        <td className="px-6 py-2 whitespace-nowrap text-sm text-gray-700 pl-8">
                                            {income.income_type}
                                        </td>
                                        <td className="px-6 py-2 whitespace-nowrap text-right text-sm text-gray-900">
                                            {formatCurrency(income?.amount)}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr className="even:bg-gray-50">
                                    <td colSpan="2" className="px-6 py-2 text-center text-sm text-gray-500">No income records for this period.</td>
                                </tr>
                            )}
                            <tr className="bg-gray-100">
                                <td className="px-6 py-3 whitespace-nowrap text-lg font-bold text-gray-800">
                                    Expenses
                                </td>
                                <td className="px-6 py-3 whitespace-nowrap text-right"></td>
                            </tr>
                            {incomeStatement?.expenses?.length > 0 ? (
                                incomeStatement.expenses.map((expense, index) => (
                                    <tr key={index} className="even:bg-gray-50 hover:bg-red-50 transition-colors duration-150">
                                        <td className="px-6 py-2 whitespace-nowrap text-sm text-gray-700 pl-8">
                                            {expense.expense_type}
                                        </td>
                                        <td className="px-6 py-2 whitespace-nowrap text-right text-sm text-gray-900">
                                            {formatCurrency(expense?.amount)}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr className="even:bg-gray-50">
                                    <td colSpan="2" className="px-6 py-2 text-center text-sm text-gray-500">No expense records for this period.</td>
                                </tr>
                            )}
                            <tr className={`${incomeStatement?.net_income >= 0 ? 'bg-green-50 text-green-800' : 'bg-red-50 text-red-800'} font-extrabold text-xl`}>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    NET INCOME
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-right">
                                    GHS {incomeStatement?.net_income}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            ) : (
                <div className="bg-white shadow-lg rounded-xl p-8 text-center text-gray-600 border border-gray-200">
                    <p className="text-lg font-medium mb-4">Select a date range and click "Get Statement" to view your financial performance.</p>
                    {startDate && endDate && !gettingData && dataFetched && (
                        <p className="text-red-500">No income or expense data available for the selected period.</p>
                    )}
                </div>
            )}
        </div>
    );
};

export default ProfitLossStatement;